import { useTranslation } from 'react-i18next'
import { useResponsiveValue } from '@machobear/design-system'
import ListingTableHeader from '@/components/listings-table-header'
import { FilterBar, FilterTextWrapper } from '@/components/search-filter'
import { TabMenu } from '@/components/tabs'

const CompanyListingsHeader = ({
  pageTitle,
  pageDescription,
  tabCount,
  currentTab,
  setCurrentTab,
  onSearch,
  buttonComponent
}) => {
  const { t } = useTranslation()
  const isMobile = useResponsiveValue()({
    mobile: true,
    tablet: false
  })

  const menuItems = [
    {
      key: 'rented',
      onClick: () => setCurrentTab('rented'),
      isActive: currentTab === 'rented',
      children: (
        <FilterTextWrapper>
          {t('l.listing.list.rented.button', 'Rented')}
          <span>({tabCount.rented})</span>
        </FilterTextWrapper>
      )
    },
    {
      key: 'published',
      onClick: () => setCurrentTab('published'),
      isActive: currentTab === 'published',
      children: (
        <FilterTextWrapper>
          {t('l.listing.list.published.button', 'Published')}
          <span>({tabCount.published})</span>
        </FilterTextWrapper>
      )
    },
    {
      key: 'draft',
      onClick: () => setCurrentTab('draft'),
      isActive: currentTab === 'draft',
      children: (
        <FilterTextWrapper>
          {t('l.listing.list.draft.button', 'Draft')}
          <span>({tabCount.draft})</span>
        </FilterTextWrapper>
      )
    }
  ]

  return (
    <ListingTableHeader
      title={pageTitle}
      description={pageDescription}
      onSearch={onSearch}
      buttonComponent={buttonComponent}
      maxWidth="900px"
    >
      <FilterBar>
        <TabMenu
          options={menuItems}
          theme={isMobile ? 'primary' : 'secondary'}
          size="medium"
          height={isMobile && 44}
        />
      </FilterBar>
    </ListingTableHeader>
  )
}

export default CompanyListingsHeader
